<template lang="pug">
  div
    div.relative.justify-center(
      :class="{'d-flex': !isMobile}"
      v-if="isVideos"
      @mouseover="hover = true"
      @mouseleave="hover = false"
    )
      youtube-embed(
        v-if="extendedVideos[model].isYouTube",
        :link="extendedVideos[model].link"
        :height="height"
      )
      iframe(
        v-else
        :key="extendedVideos[model].id"
        :height="height"
        width="100%"
        :src="extendedVideos[model].link"
        frameBorder="0"
        allow="clipboard-write; autoplay"
        webkitAllowFullScreen
        mozallowfullscreen
      )
      v-slide-group(
        v-if="isDisplaySlider"
        :class="{absolute: !isMobile}"
        v-model="model"
        next-icon="mdi-arrow-right-circle"
        prev-icon="mdi-arrow-left-circle"
        show-arrows
      ).mx-auto.d-flex.mt-5
        v-slide-item(
          v-slot="{ active, toggle }"
          v-for="(video, i) in extendedVideos"
          :class="{opacity: !isMobile}"
          :key="i"
        )
          .text-center
            v-card.sdo-card.ma-1(@click="toggle" width="200" height="110")
              youtube-embed(
                v-if="video.isYouTube"
                :img="video.link"
              )
              v-card-title.align-self-center(v-else-if="video.isRutube") {{ video.name }}
            .caption(v-if="video.isYouTube" ) {{ video.name }}
    div(v-else)
      p Видеоматериалы отсутствуют...
</template>

<script>
import YoutubeEmbed from '@/components/Global/YoutubeEmbed.vue';

export default {
  name: 'ContentVideos',
  components: {
    YoutubeEmbed,
  },
  props: {
    videos: { type: Array, default: null },
  },
  data() {
    return {
      model: 0,
      hover: false,
    };
  },
  computed: {
    extendedVideos() {
      return this.videos.map((video) => {
        if (video.link.includes('rutube')) {
          const anchor = document.createElement('a');
          anchor.href = video.link;
          let videoPas;
          if (anchor.search) {
            const queryStrings = anchor.search.substring(1);
            const urlParams = new URLSearchParams(queryStrings);
            videoPas = urlParams.get('p');
          }
          // eslint-disable-next-line prefer-destructuring
          const urlSplited = anchor.pathname.substring(1).split('/');
          const id = urlSplited[urlSplited.length - 1] || urlSplited[urlSplited.length - 2];
          const link = `https://rutube.ru/play/embed/${id}${videoPas ? `/?p=${videoPas}` : ''}`;
          return {
            isYouTube: false,
            isRutube: true,
            ...video,
            link,
          };
        }
        if (video.link.includes('youtube')) {
          return {
            isYouTube: true,
            ...video,
          };
        }
        return video;
      });
    },
    isDisplaySlider() {
      return this.hover || this.isMobile;
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    isVideos() {
      return this.videos.length;
    },
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '360';
        case 'sm': return '500';

        default: return '720';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .opacity {
    opacity: .5;
  }
  .opacity:hover {
    opacity: 1;
  }
  .relative{
    position: relative;
  }
  .absolute {
    position: absolute;
    bottom: 50px;
  }
  .v-icon.v-icon {
    background: white;
  }
</style>
